// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3kVe6","errors":"Errors_errors__2ly6t"};